var React = require('react');

function SquareMinusInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8 12.7046H16","stroke":"#0A9E50","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M9 22.7046H15C20 22.7046 22 20.7046 22 15.7046V9.70459C22 4.70459 20 2.70459 15 2.70459H9C4 2.70459 2 4.70459 2 9.70459V15.7046C2 20.7046 4 22.7046 9 22.7046Z","stroke":"#0A9E50","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

SquareMinusInline.defaultProps = {"width":"24","height":"25","viewBox":"0 0 24 25","fill":"none"};

module.exports = SquareMinusInline;

SquareMinusInline.default = SquareMinusInline;
